<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import ClipBoard from "@/common/components/ClipBoard.vue";
import PlainLayout from "@/layouts/PlainLayout.vue";

definePage({
  meta: {
    auth: [],
    layout: PlainLayout,
  },
});

const route = useRoute();
const code = computed(() => route.query.code as string | undefined);
const error = computed(() => route.query.error as string | undefined);
</script>

<template>
  <div class="flex flex-col items-center bg-gray-100 mt-24">
    <div class="bg-white p-12 rounded-md flex flex-col items-center">
      <template v-if="code">
        <h1 class="text-xl font-semibold mb-4">CLI Authorization Code</h1>
        <p class="text-gray-600 mb-4">
          Copy this code and paste it in your terminal:
        </p>
        <div class="flex items-center gap-2 bg-gray-100 p-4 rounded">
          <code class="font-mono text-lg select-all">{{ code }}</code>
          <ClipBoard
            value-to-show=""
            :value-to-copy="code!"
          />
        </div>
        <p class="text-gray-500 text-sm mt-4">
          You can close this window after copying.
        </p>
      </template>
      <template v-else-if="error">
        <h1 class="text-xl font-semibold text-red-600 mb-4">
          Authentication Failed
        </h1>
        <p class="text-gray-600">{{ error }}</p>
      </template>
      <template v-else>
        <h1 class="text-xl font-semibold text-gray-600 mb-4">
          Invalid Request
        </h1>
        <p class="text-gray-600">
          No authorization code or error was provided.
        </p>
      </template>
    </div>
  </div>
</template>
